module.exports = __webpack_public_path__ + "static/media/foto2.37592307.png";